<template>
	<div class="content-wrapper">
		<!-- Content -->
		<div class="spinner-border spinner-border-lg text-primary load-center" role="status" v-if="isLoading">
			<span class="visually-hidden">Loading...</span>
		</div>

		<div class="container flex-grow-1 container-p-y" v-if="!isLoading" style="padding-top: 0px !important;">
			<div class="row">
				<div class="col-12">
					<div class="card">
						<div
							class="card-header sticky-element bg-label-secondary d-flex justify-content-sm-between align-items-sm-center flex-column flex-sm-row">
							<h5 class="card-title mb-sm-0 me-2">{{ $t('trainings.permisT.configure') }}</h5>
						</div>
						<div class="card-body">
							<div class="row">
								<div class="card-body mb-0 pb-0">
									<div class="alert alert-primary alert-dismissible mb-0" role="alert">
										<h4 class="alert-heading d-flex align-items-center">
											<span class="alert-icon rounded">
												<i class="ri-information-line"></i>
											</span>{{ $t('trainings.permisT.importantInfo') }}
										</h4>
										<p class="mb-0">
											{{ $t('trainings.permisT.inPersonInfo') }}
										</p>
										<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
									</div>
								</div>

								<div class="col-lg-8 mx-auto">
									<h5 class="my-6">{{ $t('trainings.permisT.selectTrainee') }}</h5>
									<div class="row gy-3">
										<div class="col-md">
											<div class="form-check custom-option custom-option-icon">
												<select id="defaultSelect" class="form-select" v-model="selectedEmployee">
													<option disabled value="">{{ $t('trainings.permisT.selectEmployee') }}</option>
													<option 
														v-for="employee in employees" 
														:key="employee._id" 
														:value="employee._id">
														{{ employee.firstName }} {{ employee.lastName }} 
														( {{ $t('trainings.permisT.theoryValidated', { date: formatDate(employee.finishedAt) }) }} )
													</option>
												</select>
											</div>
										</div>
									</div>
								</div>
								<div class="col-lg-8 mx-auto">

								<!-- 2. Delivery Type -->
								<h5 class="my-6">{{ $t('trainings.permisT.availableSlots') }}</h5>
									<div class="row gy-3">
										<div class="col-12">
											<div class="alert alert-secondary" role="alert" v-if="availableSlots.length === 0">
												{{ $t("trainings.permisT.noSlots") }}
											</div>
											<div class="slots-container">
												<div 
													v-for="slot in availableSlots" 
													:key="slot.id"
													class="slot-item"
													:class="{ 'selected': selectedSlot && selectedSlot.id === slot.id }"
													@click="selectSlot(slot)">
													<div class="slot-date">
														<i class="bx bx-calendar me-2"></i>
														{{ formatDate(slot.date) }}
													</div>
													<div class="slot-time">
														<i class="bx bx-time me-2"></i>
														{{ slot.startTime }} - {{ slot.endTime }}
													</div>
													<div class="slot-status" v-if="slot.available">
														<span class="badge bg-label-success">{{ $t('trainings.permisT.available') }}</span>
													</div>
													<div class="slot-status" v-else>
														<span class="badge bg-label-danger">{{ $t('trainings.permisT.full') }}</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="col-lg-8 mx-auto mt-2 mb-5">
									<div class="form-check form-check-primary mt-4">
										<input class="form-check-input" type="checkbox" value="true" id="customCheckPrimary" checked v-model="securityCheckAcknowledged" />
										<label class="form-check-label" for="customCheckPrimary">
										{{ $t("trainings.permisT.driverLicenseConfirm") }}</label>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">
						<div class="d-flex flex-column justify-content-center">
							
						</div>
						<div class="d-flex align-content-center flex-wrap gap-4 mt-5">
							<button class="btn btn-outline-secondary" @click="backToTrainings()">{{ $t('common.actions.back') }}</button>
							<button type="submit" class="btn btn-primary" @click="registerTrainee()" 
							v-if="selectedSlot && selectedEmployee && securityCheckAcknowledged">{{ $t('trainings.permisT.confirmRegistration') }}</button>
							<button type="submit" class="btn btn-primary disabled" v-else>{{ $t('trainings.permisT.confirmRegistration') }}</button>
						</div>
					</div>
				</div>
			</div>

		</div>
		<!-- / Content -->

		<div class="content-backdrop fade"></div>
	</div>
</template>

<script>
import HTTP from "@/axios";

export default {
	name: "PermisT",

	data() {
		return {
			company: null,
			orderNumber: null,
			isLoading: false,
			employees: [],
			errors: {},
			selectedSlot: null,
			selectedEmployee: null,
			availableSlots: [],
			securityCheckAcknowledged: false
		};
	},

	methods: {
		async fetchCompany() {
			try {
				const response = await HTTP('/company');
				this.company = response.data.company;
			} catch (error) {
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');
				alert(errorMessage);
				console.error("Erreur API:", error);
			}
		},

		getEmployeeFirstname(selectedId) {
			const employee = this.employees.find(emp => String(emp._id) === String(selectedId));
			return employee;
		},

		backToTrainings() {
			this.$router.push("/trainings/create");
		},

		async registerTrainee() {
			this.isLoading = true;

			try {
				await HTTP.post('/permis-t/register-employee', {
					employee: this.selectedEmployee,
					selectedSlot: this.selectedSlot.id
				});

				this.$router.push("/trainings/success");
			} catch (error) {
				this.isLoading = false;
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');
				alert(errorMessage);
				console.error("Erreur API:", error);
			}
		},

		async fetchEmployees() {
			try {
				const response = await HTTP('/permis-t/employees');
				this.employees = response.data.employees;
			} catch (error) {
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');
				alert(errorMessage);
				console.error("Erreur API:", error);
			}
		},

		async fetchSlots() {
			try {
				const response = await HTTP('/permis-t/slots');
				this.availableSlots = response.data.availableSlots;
			} catch (error) {
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');
				alert(errorMessage);
				console.error("Erreur API:", error);
			}
		},

		selectSlot(slot) {
			if (slot.available) {
				this.selectedSlot = slot;
			}
		},

		formatDate(dateString) {
			const date = new Date(dateString);
			const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
			return date.toLocaleDateString('fr-FR', options);
		}
	},

	async mounted() {
		this.fetchCompany();
		this.fetchEmployees();
		this.fetchSlots();
	},
};
</script>

<style scoped>
.load-center {
	display: block;
	margin: 0 auto;
}

.dashboard {
	padding: 1rem;
}

.card-title {
	font-size: 1.2rem;
}

.card-text {
	margin: 0;
}

.modal-simple .modal-content {
	padding: 3rem;
}

.pb-20 {
	padding-bottom: 20px;
}

/* Styles pour les slots */
.slots-container {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 1rem;
}

.slot-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1.25rem;
	border: 2px solid #e7e7e7;
	border-radius: 8px;
	cursor: pointer;
	transition: all 0.3s ease;
	background-color: #fff;
}

.slot-item:hover:not(.slot-item:has(.badge.bg-label-danger)) {
	border-color: #696cff;
	background-color: #f8f8ff;
	transform: translateY(-2px);
	box-shadow: 0 4px 8px rgba(105, 108, 255, 0.15);
}

.slot-item.selected {
	border-color: #696cff;
	background-color: #f8f8ff;
	box-shadow: 0 4px 12px rgba(105, 108, 255, 0.2);
}

.slot-item:has(.badge.bg-label-danger) {
	opacity: 0.6;
	cursor: not-allowed;
}

.slot-date {
	display: flex;
	align-items: center;
	font-weight: 600;
	font-size: 1rem;
	color: #566a7f;
}

.slot-time {
	display: flex;
	align-items: center;
	font-size: 0.95rem;
	color: #697a8d;
}

.slot-status {
	margin-left: auto;
}

@media (max-width: 768px) {
	.slots-container {
		grid-template-columns: 1fr;
	}

	.slot-item {
		flex-direction: column;
		align-items: flex-start;
		gap: 0.5rem;
	}

	.slot-status {
		margin-left: 0;
		margin-top: 0.5rem;
	}
}
</style>